// src/components/AddToCart.js
import React from "react";
import { Button, Box, CircularProgress } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

import { useData } from "../hooks/useData";
import { useEcommerce } from "../hooks/useEcommerce";
import { usePricing } from "../hooks/usePricing";

const AddToCart = () => {
  const { canvas, mivaGlobals, basketItem, quantity, setSnackbar } = useData();
  const { totalPrice } = usePricing();

  // USE ONLY THE HOOK'S STATE — NO LOCAL STATE
  const { vinylAddToBasket, isAddingToCart } = useEcommerce();

  const isLoading = isAddingToCart;

  const handleClick = async () => {
    try {
      if (!canvas?.getObjects().length) {
        throw new Error("Please add text to your design.");
      }
      if (!basketItem?.lines?.length) {
        throw new Error("No lines in design.");
      }
      if (totalPrice <= 0) {
        throw new Error("Price error.");
      }

      for (const line of basketItem.lines) {
        if (!line.phrase?.trim()) continue;

        const json_basket = {
          function: "Action_AddProductToBasket",
          Product_Code: basketItem.productCode,
          Quantity: Number(quantity),
          Product_Attribute_Count: 4,
          update_price: Number(line.price),
          Product_Attributes: [
            { value: line.phrase, code: "Phrase" },
            { value: line.font, template_code: "Font", code: "Fonts_Vinyl" },
            {
              value: line.color,
              template_code: "Color",
              code:
                basketItem.productCode === "VL0200"
                  ? "Colors_Premium_Vinyl"
                  : "Reflective_Vinyl_Colors",
            },
            { value: line.size, code: "Size" },
          ],
          basket_id: mivaGlobals.basketid,
          session_id: mivaGlobals.sessionid,
        };

        await vinylAddToBasket(json_basket);
      }

      setSnackbar({
        open: true,
        message: "Added to cart!",
        severity: "success",
      });
      window.location.href = "https://www.alphabetsigns.com/cart-contents.html";
    } catch (error) {
      console.error("ADD TO CART ERROR:", error);
      setSnackbar({ open: true, message: error.message, severity: "error" });
    }
  };

  const disabled =
    !canvas?.getObjects().length ||
    !basketItem?.lines?.length ||
    totalPrice <= 0;

  return (
    <Box sx={{ width: "100%" }}>
      <Button
        variant="contained"
        color="success"
        size="large"
        fullWidth
        disabled={disabled || isAddingToCart}
        onClick={handleClick}
        startIcon={
          isAddingToCart ? <CircularProgress size={20} /> : <ShoppingCartIcon />
        }
        sx={{ py: 1.8, fontWeight: "bold", fontSize: "1.1rem" }}
      >
        {isAddingToCart ? "Adding to Cart..." : "Add to Cart"}
      </Button>
    </Box>
  );
};

export default AddToCart;
